<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Feed', apiMethod: 'Feeds', form: () => import('../forms/FeedForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Purchases', value: 'feedId', table: () => import('../tables/FeedPurchasesTable') },
                ],
                mainForm: () => import('../forms/FeedForm'),
                claimName: 'Feeds',
                apiMethod: 'Feeds',
            }
        }
    };
</script>
